module.exports = __webpack_public_path__ + "img/ic_permission_empty.43642fa1.png";